import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import MovieCard from '@/components/base/MovieCard';
import { movies, categories } from '@/mocks/movies';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeTab, setActiveTab] = useState(slug || 'all');

  useEffect(() => {
    window.scrollTo(0, 0);
    if (slug) {
      setActiveTab(slug);
    }
  }, [slug]);

  const filteredMovies = activeTab === 'all'
    ? movies
    : movies.filter((m) => m.category === activeTab);

  const currentCategory = categories.find((c) => c.slug === activeTab);
  const pageTitle = currentCategory ? `${currentCategory.name} - 屁屁影院高清在线观看` : '全部影片 - 屁屁影院';

  const breadcrumbItems = [
    { label: '首页', path: '/' },
    { label: currentCategory?.name || '全部影片' },
  ];

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb items={breadcrumbItems} />

          <div className="py-6">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              {currentCategory?.name || '全部影片'}
              <span className="text-base font-body font-normal text-foreground-500 ml-3">
                共 {filteredMovies.length} 部
              </span>
            </h1>
          </div>

          <div className="flex items-center gap-2 pb-6 flex-wrap">
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => setActiveTab(cat.slug)}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  activeTab === cat.slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                <i className={`${cat.icon} mr-1.5`}></i>
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        <section className="py-8 md:py-12 bg-background-100 min-h-[400px]">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            {filteredMovies.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5"
                data-product-shop
              >
                {filteredMovies.map((movie) => (
                  <MovieCard
                    key={movie.id}
                    id={movie.id}
                    title={movie.title}
                    cover={movie.cover}
                    rating={movie.rating}
                    year={movie.year}
                    tags={movie.tags}
                    updateDate={movie.updateDate}
                  />
                ))}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-20">
                <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 mb-4">
                  <i className="ri-movie-2-line text-3xl"></i>
                </div>
                <p className="text-foreground-500">该分类暂无内容，敬请期待</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
      <ScrollToTop />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": pageTitle,
            "description": `屁屁影院${currentCategory?.name || '全部'}影视资源列表，提供海量高清${currentCategory?.name || '影视'}在线播放。`,
            "url": `https://streampops.github.io/category/${activeTab}`,
            "isPartOf": {
              "@type": "WebSite",
              "name": "屁屁影院",
              "url": "https://streampops.github.io/"
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "首页",
                  "item": "https://streampops.github.io/"
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": currentCategory?.name || '全部影片',
                  "item": `https://streampops.github.io/category/${activeTab}`
                }
              ]
            }
          })
        }}
      />
    </>
  );
}